import { computed } from 'vue'
import { useAppStore } from '@/stores/app-store'

export type Permission = string

export function hasPermission(
  permissions: readonly Permission[],
  permission: Permission
): boolean {
  return permissions.includes(permission)
}

function getCachedPermissions(): Permission[] {
  if (typeof document === 'undefined') return []

  return (document.body.dataset.perms ?? '').split(/\s+/).filter(Boolean)
}

export function usePermission() {
  const appStore = useAppStore()

  const permissions = computed<readonly Permission[]>(() => {
    return appStore.user?.permissions ?? getCachedPermissions()
  })

  const can = (permission: Permission | null): boolean => {
    return permission === null || hasPermission(permissions.value, permission)
  }

  return { can }
}
